'use client';

import { Title } from 'types';
import ActQuickCallout from '@/components/product/callouts/act-quick-callout';

interface ActQuickCalloutProps {
  titleData: Title;
}
export default function ActQuickCalloutClient({ titleData }: ActQuickCalloutProps) {
  return <ActQuickCallout title={titleData} />;
}